import { environment as defaultEnvironment } from '../../../environments/environment';
import { environment as stgEnvironment } from '../../../environments/environment.stag';
import { environment as prodEnvironment } from '../../../environments/environment.prod';
import { Injectable } from '@angular/core';
import { WindowRef } from '@spartacus/core';

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  constructor(private winRef: WindowRef) {}

  public getCurrentEnvironment() {
    if (this.winRef.isBrowser() && /^.*\.hisense\.com/.test(location.host)) {
      return prodEnvironment;
    } else if (this.winRef.isBrowser() && /^.*\.hisense\.fr/.test(location.host)) {
      return prodEnvironment;
    } else if (this.winRef.isBrowser() && /^.*prod-hybris?.\.gorenje\.com/.test(location.host)) {
      return prodEnvironment;
    } else if (this.winRef.isBrowser() && /^.*prod?.\.hgecdn\.net/.test(location.host)) {
      return prodEnvironment;
    } else if (this.winRef.isBrowser() && /^.*stg-hybris?.\.gorenje\.com/.test(location.host)) {
      return stgEnvironment;
    } else if (this.winRef.isBrowser() && /^.*stg?.\.hgecdn\.net/.test(location.host)) {
      return stgEnvironment;
    } else {
      return defaultEnvironment;
    }
  }
}
